export default {
  refresh_members_datatable() {
    this.$nextTick(() => this.init_members_datatable());
  },
  refresh_companies_datatable() {
    this.$nextTick(() => this.init_companies_datatable());
  },
  refresh_invitations_datatable() {
    this.$nextTick(() => this.init_invitations_datatable());
  },
  has_datatable_plugin() {
    return typeof $ !== "undefined" && !!($.fn?.DataTable || $.fn?.dataTable);
  },
  is_members_datatable_initialized(table) {
    if (!this.has_datatable_plugin()) return false;
    if ($.fn.dataTable?.isDataTable) return $.fn.dataTable.isDataTable(table);
    if ($.fn.DataTable?.isDataTable) return $.fn.DataTable.isDataTable(table);
    return false;
  },
  get_members_table() {
    return this.$refs.organizationMembersTable;
  },
  get_companies_table() {
    return this.$refs.organizationCompaniesTable;
  },
  get_invitations_table() {
    return this.$refs.organizationInvitationsTable;
  },
  can_init_members_datatable(table) {
    if (!table) return false;
    if (!this.has_datatable_plugin()) return false;
    return !this.is_members_datatable_initialized(table);
  },
  can_init_companies_datatable(table) {
    return this.can_init_members_datatable(table);
  },
  can_init_invitations_datatable(table) {
    return this.can_init_members_datatable(table);
  },
  get_members_datatable_column_defs() {
    return this.can_manage_members
      ? [{ orderable: false, searchable: false, targets: -1 }]
      : [];
  },
  get_companies_datatable_column_defs() {
    return this.get_members_datatable_column_defs();
  },
  get_invitations_datatable_column_defs() {
    return [];
  },
  get_members_datatable_options() {
    return ({
      pageLength: 10,
      ordering: false,
      autoWidth: false,
      scrollX: false,
      dom: "lfrtip",
      search: {
        caseInsensitive: true,
        smart: true,
      },
      columnDefs: this.get_members_datatable_column_defs(),
      language: {
        emptyTable: "No members found",
        info: "Showing _START_ to _END_ of _TOTAL_ members",
        infoEmpty: "Showing 0 members",
        zeroRecords: "No matching members found",
        paginate: {
          previous: "Prev",
          next: "Next",
        },
      },
    });
  },
  get_companies_datatable_options() {
    return ({
      ...this.get_members_datatable_options(),
      columnDefs: this.get_companies_datatable_column_defs(),
      language: {
        emptyTable: "No companies found",
        info: "Showing _START_ to _END_ of _TOTAL_ companies",
        infoEmpty: "Showing 0 companies",
        zeroRecords: "No matching companies found",
        paginate: {
          previous: "Prev",
          next: "Next",
        },
      },
    });
  },
  get_invitations_datatable_options() {
    return ({
      ...this.get_members_datatable_options(),
      columnDefs: this.get_invitations_datatable_column_defs(),
      language: {
        emptyTable: "No invitations found",
        info: "Showing _START_ to _END_ of _TOTAL_ invitations",
        infoEmpty: "Showing 0 invitations",
        zeroRecords: "No matching invitations found",
        paginate: {
          previous: "Prev",
          next: "Next",
        },
      },
    });
  },
  init_members_datatable() {
    const table = this.get_members_table();
    if (!this.can_init_members_datatable(table)) return;

    this.members_table_instance = $(table).DataTable(this.get_members_datatable_options());
    this.search_members_table(this.search_query);
  },
  init_companies_datatable() {
    const table = this.get_companies_table();
    if (!this.can_init_companies_datatable(table)) return;

    this.companies_table_instance = $(table).DataTable(this.get_companies_datatable_options());
  },
  init_invitations_datatable() {
    const table = this.get_invitations_table();
    if (!this.can_init_invitations_datatable(table)) return;

    this.invitations_table_instance = $(table).DataTable(this.get_invitations_datatable_options());
  },
  destroy_members_datatable() {
    const table = this.$refs.organizationMembersTable;
    if (!table || !this.has_datatable_plugin()) return;

    if (this.is_members_datatable_initialized(table)) {
      $(table).DataTable().clear().destroy();
    }
    this.members_table_instance = null;
  },
  destroy_companies_datatable() {
    const table = this.$refs.organizationCompaniesTable;
    if (!table || !this.has_datatable_plugin()) return;

    if (this.is_members_datatable_initialized(table)) {
      $(table).DataTable().clear().destroy();
    }
    this.companies_table_instance = null;
  },
  destroy_invitations_datatable() {
    const table = this.$refs.organizationInvitationsTable;
    if (!table || !this.has_datatable_plugin()) return;

    if (this.is_members_datatable_initialized(table)) {
      $(table).DataTable().clear().destroy();
    }
    this.invitations_table_instance = null;
  },
  sync_members_table_instance() {
    const table = this.get_members_table();
    if (!table) return;
    if (!this.is_members_datatable_initialized(table)) return;
    this.members_table_instance = $(table).DataTable();
  },
  get_members_table_search_value(value) {
    return String(value || "").trim();
  },
  search_members_table(value) {
    if (!this.members_table_instance) this.sync_members_table_instance();
    if (!this.members_table_instance) return;
    this.members_table_instance.search(this.get_members_table_search_value(value)).draw();
  },
  remove_member_from_datatable(member_id) {
    if (!this.members_table_instance) this.sync_members_table_instance();
    if (!this.members_table_instance) return false;

    const member_id_value = String(member_id);
    const row_node = this.members_table_instance
      .rows()
      .nodes()
      .toArray()
      .find((node) => String(node?.dataset?.memberId || "") === member_id_value);

    if (!row_node) return false;
    this.members_table_instance.row(row_node).remove().draw(false);
    return true;
  },
  clear_member_search() {
    this.search_query = "";
  },
};
